module.exports = __webpack_public_path__ + "banner3.ed36a505a34c501e37e7.png";